import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const paragraphStaticStyle = css({
    marginBottom: tokens.spacingNew.xsmall,
});
export function paragraphStyle({ inverted, variant }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        paragraphStaticStyle,
        css(Object.assign({}, (variant === 'secondary' && { color: theme.text.subtle }))),
    ];
}
